import { Grid, Typography } from '@mui/material';
import CustomAreaChart from '../CustomAreaChart';
import { ArmsResult } from './AIResult/ArmsResult';

const acceleratorDomain = [-10, 10]; //see https://recharts.org/en-US/api/YAxis domain
const gyroDomain = [-5, 5]; //see https://recharts.org/en-US/api/YAxis domain

export function Arms({ armsData, deviceDescription, model1Result }) {
  const isAppleDevice = !deviceDescription;

  const scaleAcceleratorData = (data) => {
    const accel = data.accel.map((d) => ({ ...d, x: d.x * 9.8, y: d.y + 9.8, z: d.z * 9.8 }));
    return isAppleDevice ? { ...data, accel } : data;
  };

  const normalizeArmsData = (data, device) => {
    data = data[device];
    data = data.map((obj) => {
      return { val: Math.sqrt(Math.pow(obj.x, 2) + Math.pow(obj.y, 2) + Math.pow(obj.z, 2)), timestamp: obj.timestamp };
    });
    //Zero mean - we make the values linger around the horisontal axis by substracting the avg value from each one.
    const avgVal = data.reduce((a, b) => a + b.val, 0) / data.length;
    const timestamps = data.map((obj) => obj.timestamp);
    const minTS = Math.min(...timestamps);
    data = data.map((obj) => {
      return {
        timestamp: obj.timestamp - minTS,
        val: obj.val - avgVal,
      };
    });
    return data;
  };

  return (
    <>
      {armsData ? (
        <Grid container sx={{ overflowX: 'scroll', overflowY: 'scroll' }}>
          <Grid item xs={6}>
            <Typography
              sx={{
                fontSize: '1.7em',
                textAlign: 'center',
              }}
            >
              Left Arm
            </Typography>
            {armsData.armMovement ? (
              armsData.armMovement.left.accel.length > 0 ? (
                <>
                  <Typography
                    component="h5"
                    sx={{
                      fontSize: '1.5em',
                      textAlign: 'center',
                    }}
                  >
                    Accelerometer
                  </Typography>
                  <CustomAreaChart domain={acceleratorDomain} width={490} data={normalizeArmsData(scaleAcceleratorData(armsData.armMovement.left), 'accel')} x_label="timestamp" y_label="val"></CustomAreaChart>
                  <Typography
                    component="h5"
                    sx={{
                      fontSize: '1.5em',
                      textAlign: 'center',
                    }}
                  >
                    Gyroscope
                  </Typography>
                  <CustomAreaChart domain={gyroDomain} width={490} data={normalizeArmsData(armsData.armMovement.left, 'gyro')} x_label="timestamp" y_label="val"></CustomAreaChart>
                  <Typography
                    component="h5"
                    sx={{
                      fontSize: '1.5em',
                      textAlign: 'center',
                    }}
                  >
                    Magnetometer
                  </Typography>
                  <CustomAreaChart width={490} data={normalizeArmsData(armsData.armMovement.left, 'magnet')} x_label="timestamp" y_label="val"></CustomAreaChart>
                </>
              ) : (
                <Typography
                  component="h5"
                  sx={{
                    fontSize: '1.5em',
                    textAlign: 'center',
                    marginBottom: '8px',
                  }}
                >
                  Test marked as impossible
                </Typography>
              )
            ) : (
              <Typography
                component="h5"
                sx={{
                  fontSize: '1.5em',
                  textAlign: 'center',
                  color: 'red',
                  marginBottom: '8px',
                }}
              >
                No arms data provided for test
              </Typography>
            )}
          </Grid>
          <Grid item xs={6}>
            <Typography
              sx={{
                fontSize: '1.7em',
                textAlign: 'center',
              }}
            >
              Right Arm
            </Typography>
            {armsData.armMovement ? (
              armsData.armMovement.right.accel.length > 0 ? (
                <>
                  <Typography
                    component="h5"
                    sx={{
                      fontSize: '1.5em',
                      textAlign: 'center',
                    }}
                  >
                    Accelerometer
                  </Typography>
                  <CustomAreaChart domain={acceleratorDomain} width={490} data={normalizeArmsData(scaleAcceleratorData(armsData.armMovement.right), 'accel')} x_label="timestamp" y_label="val"></CustomAreaChart>
                  <Typography
                    component="h5"
                    sx={{
                      fontSize: '1.5em',
                      textAlign: 'center',
                    }}
                  >
                    Gyroscope
                  </Typography>
                  <CustomAreaChart domain={gyroDomain} width={490} data={normalizeArmsData(armsData.armMovement.right, 'gyro')} x_label="timestamp" y_label="val"></CustomAreaChart>
                  <Typography
                    component="h5"
                    sx={{
                      fontSize: '1.5em',
                      textAlign: 'center',
                    }}
                  >
                    Magnetometer
                  </Typography>
                  <CustomAreaChart width={490} data={normalizeArmsData(armsData.armMovement.right, 'magnet')} x_label="timestamp" y_label="val"></CustomAreaChart>
                </>
              ) : (
                <Typography
                  component="h5"
                  sx={{
                    fontSize: '1.5em',
                    textAlign: 'center',
                    marginBottom: '8px',
                  }}
                >
                  Test marked as impossible
                </Typography>
              )
            ) : (
              <Typography
                component="h5"
                sx={{
                  fontSize: '1.5em',
                  textAlign: 'center',
                  color: 'red',
                  marginBottom: '8px',
                }}
              >
                No arms data provided for test
              </Typography>
            )}
          </Grid>
        </Grid>
      ) : (
        ''
      )}
      {model1Result ? <ArmsResult sx={{ marginLeft: '40px' }} model1Result={model1Result} title="FAST AI Score" /> : null}
    </>
  );
}
